// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonState } from "@1js/acui-button/lib/Next";
import {} from "@fluentui/react-components";
import { customTokens } from "@1js/acui-theme";
import {
  makeStyles,
  mergeClasses,
  shorthands,
  useMenuButtonStyles_unstable,
} from "@fluentui/react-components";
// eslint-disable-next-line no-restricted-imports
import { useCommonDisabledStyles } from "@1js/acui-common/lib/styling/next";
import { controlStylingConstants } from "@1js/acui-common";
import * as React from "react";
import { AppContext } from "@1js/acui-context";
import { useMinimumTargetSizesIsEnabled } from "@1js/acui-experiments";

const useMenuButtonStyles = makeStyles({
  base: {
    minWidth: "16px",
    padding: "0px",
    backgroundColor: customTokens.colorNeutralBackground1,
    ...shorthands.border(
      customTokens.strokeWidthThin,
      "solid",
      customTokens.colorNeutralStroke1
    ),
    borderRadius: customTokens.borderRadiusMedium,
    // The left of this component is where the button display is located, setting the border left
    // to none so just the menu button can display the border
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
  baseWithMinTargetSize: {
    minWidth: `${controlStylingConstants.minTargetSize}px`,
  },
});

const useMenuButtonIconStyles = makeStyles({
  base: {
    margin: "0px",
  },
});

export const usePreviewGalleryMenuButtonStyles = (
  state: AppMenuButtonState
): AppMenuButtonState => {
  const menuButtonStyles = useMenuButtonStyles();
  const menuButtonIconStyles = useMenuButtonIconStyles();
  const disabledStyles = useCommonDisabledStyles();

  const context = React.useContext(AppContext);
  const minTargetSizesEnabled = useMinimumTargetSizesIsEnabled(context);

  state.root.className = mergeClasses(
    menuButtonStyles.base,
    minTargetSizesEnabled && menuButtonStyles.baseWithMinTargetSize,
    "ms-ButtonNext",
    "ms-Button",
    state.root.className
  );

  if (state.menuIcon) {
    state.menuIcon.className = mergeClasses(
      "ms-Button-icon",
      menuButtonIconStyles.base,
      (state?.disabled || state?.disabledFocusable) && disabledStyles.base,
      state.menuIcon.className
    );
  }

  useMenuButtonStyles_unstable(state);

  return state;
};
